import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "site-message-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close-white" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showNotification)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["site-messages js-site-msgs", {
        'is-show': _ctx.showNotification,
        'is-animate-hide': _ctx.notificationIsClosing,
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, _toDisplayString(_ctx.notificationMessage), 1),
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
              class: "js-close-site-message site-message-item__close",
              style: {"cursor":"pointer"}
            }, _hoisted_3)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}